import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  onboardingLandingPage: {
    loading: false,
    error: null,
    data: null,
  },
  deviceName: {
    loading: false,
    error: null,
    data: null,
  },
  activeSupportProgramType: null,
}

const cgmSlice = createSlice({
  name: 'cgm',
  initialState,
  reducers: {
    fetchCgmOnboardingLandingPageRequest: (state, action) => {
      state.onboardingLandingPage.loading = true
      state.onboardingLandingPage.error = null
      state.onboardingLandingPage.data = null
    },
    fetchCgmOnboardingLandingPageSuccess: (state, action) => {
      state.onboardingLandingPage.loading = false
      state.onboardingLandingPage.error = null
      state.onboardingLandingPage.data = action.payload
    },
    fetchCgmOnboardingLandingPageError: (state, action) => {
      state.onboardingLandingPage.loading = false
      state.onboardingLandingPage.data = null
      state.onboardingLandingPage.error = action.payload
    },
    setCgmDeviceNameRequest: (state, action) => {
      state.deviceName.loading = true
      state.deviceName.error = null
      state.deviceName.data = null
    },
    setCgmDeviceNameSuccess: (state, action) => {
      state.deviceName.loading = false
      state.deviceName.error = null
      state.deviceName.data = action.payload
    },
    setCgmDeviceNameError: (state, action) => {
      state.deviceName.loading = false
      state.deviceName.data = null
      state.deviceName.error = action.payload
    },
    setActiveSupportProgramType: (state, action) => {
      state.activeSupportProgramType = action.payload
    },
  },
})

export const {
  fetchCgmOnboardingLandingPageRequest,
  fetchCgmOnboardingLandingPageSuccess,
  fetchCgmOnboardingLandingPageError,
  setCgmDeviceNameRequest,
  setCgmDeviceNameSuccess,
  setCgmDeviceNameError,
  setActiveSupportProgramType,
} = cgmSlice.actions

export default cgmSlice.reducer
